import { Component, OnInit, ViewChild } from '@angular/core';
import { DxFormModule, DxButtonModule, DxValidatorModule, DxFormComponent } from 'devextreme-angular';
import { RestApiService } from '../../shared/services/rest-api.service';
import { JustificationNote } from '../../shared/models/justification-note';
import { JustificationService } from '../../shared/services/justification.service';
import { Justification } from '../../shared/models/justification';
import { DxButtonTypes } from 'devextreme-angular/ui/button';
import notify from 'devextreme/ui/notify';
import { Router } from '@angular/router';
import { ToolbarService } from 'src/app/shared/services/toolbar.service';

@Component({
    selector: 'app-justification-form',
    imports: [
        DxFormModule,
        DxButtonModule,
        DxValidatorModule
    ],
    templateUrl: './justification-form.component.html',
    styleUrl: './justification-form.component.scss'
})
export class JustificationFormComponent implements OnInit {
  @ViewChild(DxFormComponent, { static: false }) dxForm!: DxFormComponent;
  justificationForm: { day: Date, justification: string, note: string } = {
    day: new Date(),
    justification: '',
    note: ''
  };
  tenantId: number;
  workerNumber: string | undefined;
  justificationOptions: Justification[] = [];
  constructor(private apiService: RestApiService,
              private justificationService: JustificationService,
              private toolbar: ToolbarService,
              private router: Router) {
    this.tenantId = Number(localStorage.getItem("tenantId"));
    this.workerNumber = localStorage.getItem("user")?.substring(3);
  }

  ngOnInit(): void {
    //richiamo il servizio che mi permette di leggere i dati passati dalla tabella al form di giustifica
    this.justificationService.getJustification().subscribe(justification => {
      this.justificationForm.justification = justification;
    });
    this.justificationService.getNote().subscribe(note => {
      this.justificationForm.note = note;
    });
    this.justificationService.getDate().subscribe(date => {
      this.justificationForm.day = date;
    })

    this.toolbar.PlusVisibleChanged(false);
    this.toolbar.MenuVisibleChanged(false);

    this.loadData();
  }

  //leggo le giustificazioni dal database
  loadData(): void {
    this.apiService.getJustifications(this.tenantId!).subscribe(data => {
      this.justificationOptions = data;
    });
  }

  onFormSubmit = (e: any) => {
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
    }

    //converto la data nel formato corretto
    const day = this.justificationForm.day;
    const correctedDate = new Date(day.getTime() - (day.getTimezoneOffset() * 60000));
    const isoString = correctedDate.toISOString();

    // Crea l'oggetto da inviare nell'operazione di post
    const justificationNoteDto: JustificationNote = {
      tenantId: this.tenantId,
      workerNumber: this.workerNumber!,
      day: isoString,
      justification: this.justificationForm.justification,
      note: this.justificationForm.note
    }; 

    // Chiamata al servizio per inviare i dati
    this.apiService.postJustificationNote(justificationNoteDto).subscribe(() => {
      // Notifica di successo
      notify({
        message: 'Inserimento avvenuto con successo',
        position: {
          my: 'center top',
          at: 'center top',
        },
      }, 'success', 3000);
      this.router.navigate(['/card-clock']); 
    });
  };

  registerButtonOptions: DxButtonTypes.Properties = {
    text: 'Invia',
    type: 'success',
    width: '120px',
    useSubmitBehavior: true,
    onClick: (e) => {
      const validationResult = this.dxForm.instance.validate();
      //eseguo il submit solo se il form è corretto
      if (validationResult.isValid) {
        this.onFormSubmit(e);
      }
    }
  };
}
